var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "schoolView" }, [
    _c(
      "div",
      { staticClass: "addEditForm" },
      [
        _c("div", { staticClass: "formTitle" }, [_vm._v("新增教育局信息")]),
        _vm._v(" "),
        _c(
          "el-form",
          {
            ref: "rulesForm",
            staticClass: "demo-form-inline",
            attrs: {
              model: _vm.formInline,
              rules: _vm.rules,
              "label-width": "120px",
            },
          },
          [
            _c(
              "el-row",
              { staticClass: "marRight20" },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "教育局名称", prop: "schoolName" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入教育局名称" },
                          model: {
                            value: _vm.formInline.schoolName,
                            callback: function ($$v) {
                              _vm.$set(_vm.formInline, "schoolName", $$v)
                            },
                            expression: "formInline.schoolName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "教育局编码", prop: "schoolCode" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入教育局编码" },
                          model: {
                            value: _vm.formInline.schoolCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.formInline, "schoolCode", $$v)
                            },
                            expression: "formInline.schoolCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-form-item",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.onSubmit("rulesForm")
                      },
                    },
                  },
                  [_vm._v("提交")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.isBack } },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }